<template>
    <div>
        <b-form-group v-if="!value || value.length === 0">
            <label>Firmware package file</label>
            <b-overlay :show="fileUploading">
                <b-form-file
                    v-model="firmwarePackageFile"
                    :disabled="fileUploading"
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                />
            </b-overlay>
            <b-progress v-if="fileUploading" class="mt-1" :value="progress" :max="100" show-progress></b-progress>
        </b-form-group>
        <b-form-group v-else>
            <label>Firmware package file ID</label>
            <b-input-group>
                <b-form-input :value="value" disabled/>
                <b-input-group-append>
                    <b-button variant="danger" @click="$emit('input', '')">
                        <feather-icon icon="Trash2Icon"/>
                    </b-button>
                </b-input-group-append>
            </b-input-group>
        </b-form-group>
    </div>
</template>
<script>

    import {BButton, BFormFile, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BOverlay, BProgress} from 'bootstrap-vue'

    export default {
        props: {
            value: {
                type: String,
                required: true,
                default: ''
            }
        },
        components: {
            BFormFile,
            BFormGroup,
            BButton,
            BFormInput,
            BInputGroupAppend,
            BInputGroup,
            BOverlay,
            BProgress
        },
        data() {
            return {
                firmwarePackageFile: null,
                fileUploading: false,
                progress: 0
            }
        },
        methods: {
            valid() {
                return this.value !== ''

            }
        },
        watch: {
            firmwarePackageFile() {
                if (!this.firmwarePackageFile) return
                const thisIns = this
                const formData = new FormData()
                this.fileUploading = true
                formData.append('file', this.firmwarePackageFile)

                this.progress = 0

                this.$http.post('/api/management/v1/firmware_package_file/', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    onUploadProgress(progressEvent) {
                        thisIns.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                    }
                }).then(function(response) {
                    thisIns.$printSuccess('Firmware package file uploaded')
                    thisIns.$emit('input', response.data.id)
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.firmwarePackageFile = null
                }).finally(function() {
                    thisIns.fileUploading = false
                })
            }
        }
    }

</script>